import Utils from "../../../../../../../../core/services/utils/utils";
import {PreventionInvalidityCode} from "../preventative-interactions";
import {BaseImportTransformer} from "./shared";
import {normalizeSpreadsheetCellValue} from "./shared/normalize-spreadsheet-cell-value";

/**
 * @param {*} item
 * @returns {boolean}
 */
function isExternalCustomerSeedRow(item) {
    if (!normalizeSpreadsheetCellValue(item?.customerCode)) return false;
    return !(normalizeSpreadsheetCellValue(item.internalId) && Number.isNaN(Number(normalizeSpreadsheetCellValue(item.internalId))));

}

/**
 * External customers import — phased validation (see {@link BaseImportTransformer} run contract).
 *
 * @param {Array<Object|null|undefined>} mappedData
 * @param {boolean} isFinalRun
 */
export class ExternalCustomersImportTransformer extends BaseImportTransformer {
    async run(mappedData, isFinalRun = false) {
        const rows = mappedData ?? [];
        const preventativeIssues = [];

        /** @type {{index: number, item: *, seedValid: boolean, codes: string[]}[]} */
        const rowState = rows.map((item, index) => ({
            index,
            item,
            seedValid: isExternalCustomerSeedRow(item),
            codes: [],
        }));

        // ── Phase 1: seed rule (customer code + optional numeric internal id) ───────
        for (const rs of rowState) {
            if (!rs.item) continue;
            if (!rs.seedValid) {
                rs.codes.push(PreventionInvalidityCode.MISSING_REQUIRED_FIELDS);
            }
        }

        // ── Phase 2: addUser boolean parse (legacy: invalid only when cell has a value that does not parse) ──
        for (const rs of rowState) {
            if (!rs.item) continue;
            const addUser = Utils.tryConvertStringToBoolean(rs.item.addUser);
            if (addUser === undefined && rs.item.addUser) {
                rs.codes.push(PreventionInvalidityCode.INVALID_BOOLEAN);
            }
        }

        for (const rs of rowState) {
            if (!rs.item) continue;
            if (!rs.codes.length) continue;
            preventativeIssues.push({
                rowIndex: rs.index,
                invalidityCodes: [...new Set(rs.codes)],
                originalRow: rs.item,
            });
        }

        const issueIndexSet = new Set(preventativeIssues.map((p) => p.rowIndex));

        const apiRequests = rows.map((item, index) => {
            if (!item) return null;

            const addUserParsed = Utils.tryConvertStringToBoolean(item.addUser);

            if (issueIndexSet.has(index)) {
                return isFinalRun
                    ? null
                    : {
                        internalId: item.internalId ? Number(normalizeSpreadsheetCellValue(item.internalId)) : null,
                        customerCode: normalizeSpreadsheetCellValue(item.customerCode),
                        addUser: addUserParsed === undefined ? false : addUserParsed,
                    };
            }

            return {
                internalId: item.internalId ? Number(normalizeSpreadsheetCellValue(item.internalId)) : null,
                customerCode: normalizeSpreadsheetCellValue(item.customerCode),
                addUser: addUserParsed,
            };
        });

        return {apiRequests, preventativeIssues};
    }
}
